import { render, staticRenderFns } from "./order-remark-modal.vue?vue&type=template&id=2819d984&"
import script from "./order-remark-modal.vue?vue&type=script&lang=js&"
export * from "./order-remark-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports